import { render } from "./Menu.vue?vue&type=template&id=236c98a1&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "@/assets/css/tailwind.css?vue&type=style&index=0&lang=css"
import "@/assets/css/_fontface.css?vue&type=style&index=1&lang=css"
import "@/assets/css/_variables.css?vue&type=style&index=2&lang=css"
import "@/assets/css/_global.css?vue&type=style&index=3&lang=css"
import "@/assets/css/_animations.css?vue&type=style&index=4&lang=css"
import "@/assets/css/main.css?vue&type=style&index=5&lang=css"
import "./Menu.vue?vue&type=style&index=6&id=236c98a1&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/jenkins/workspace/suiteweb-web-components_gamma/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236c98a1"]])

export default __exports__